import React from 'react'
import { Text } from 'theme-ui'

import { WebtraderProps } from './types'
import {
  WebtraderStyled,
  WebtraderMediaStyled,
  WebrtaderListStyled,
  WebrtaderListItemStyled,
  WebtraderActionStyled,
  WebtraderLabelStyled,
  WebtraderIconWrapper
} from './styles'
import Button from './../../atoms/Button'
import WebtraderMedia from '../../molecules/WebtraderMedia'

const Webtrader: React.FC<WebtraderProps> = ({ data: { cta, listItems, media, iconsList } }) => (
  <WebtraderStyled>
    {media && (
      <WebtraderMediaStyled>
        <WebtraderMedia {...{ media, iconsList }} />
      </WebtraderMediaStyled>
    )}
    {listItems && !!listItems.length && (
      <WebrtaderListStyled>
        {listItems.map((item) => (
          <WebrtaderListItemStyled key={item.key}>
            <WebtraderIconWrapper />
            <WebtraderLabelStyled as="p" variant="bodyMontserrat10">
              {item.label}
            </WebtraderLabelStyled>
          </WebrtaderListItemStyled>
        ))}
      </WebrtaderListStyled>
    )}
    {cta && cta.urlText && (
      <WebtraderActionStyled>
        <Button variant="withArrow" {...cta} />
        {/* {cta.caption && (
          <Text
            sx={{
              variant: 'bodyMontserrat7',
              fontFamily: 'primary',
              marginTop: '5px'
            }}
          >
            {cta.caption}
          </Text>
        )} */}
      </WebtraderActionStyled>
    )}
  </WebtraderStyled>
)

export default Webtrader
